(function() {
  var DELAY = 220;
  var timers = new WeakMap();
  var allowed = new WeakSet();
  var SELECTOR = '.js-header-mega-menu-toggler, .js-header-dropdown-menu-toggler';

  function isHoverMenu() {
    return !!document.querySelector('[data-open-menu-type="hover"]');
  }

  document.addEventListener('mouseenter', function(e) {
    if (!e.target.matches || !e.target.matches(SELECTOR)) return;
    if (!isHoverMenu()) return;

    var toggler = e.target;

    if (allowed.has(toggler)) {
      allowed.delete(toggler);
      return;
    }

    e.stopPropagation();
    e.stopImmediatePropagation();

    var prev = timers.get(toggler);
    if (prev) clearTimeout(prev);

    timers.set(toggler, setTimeout(function() {
      timers.delete(toggler);
      allowed.add(toggler);
      toggler.dispatchEvent(new MouseEvent('mouseenter', {
        bubbles: false,
        cancelable: false,
        view: window
      }));
    }, DELAY));
  }, true);

  document.addEventListener('mouseleave', function(e) {
    if (!e.target.matches || !e.target.matches(SELECTOR)) return;

    var toggler = e.target;
    var prev = timers.get(toggler);
    if (prev) {
      clearTimeout(prev);
      timers.delete(toggler);
    }
    allowed.delete(toggler);
  }, true);
})();
